(function () {
  if (window.__cartTermsLoaded) return;
  window.__cartTermsLoaded = true;

  function getTermsBlock(fromEl) {
    if (!fromEl) return document.querySelector('[data-cart-terms]');
    return (
      fromEl.closest('.cart__blocks, .cart-drawer__footer, .drawer__footer, cart-drawer, #main-cart-footer')
        ?.querySelector('[data-cart-terms]') ||
      fromEl.closest('[data-cart-terms]') ||
      document.querySelector('[data-cart-terms]')
    );
  }

  function isAgreed(termsBlock) {
    const checkbox = termsBlock?.querySelector('.cart-terms__checkbox');
    return !!(checkbox && checkbox.checked);
  }

  function showError(termsBlock) {
    const error = termsBlock?.querySelector('[data-cart-terms-error]');
    if (!error) return;
    error.hidden = false;
  }

  function hideError(termsBlock) {
    const error = termsBlock?.querySelector('[data-cart-terms-error]');
    if (error) error.hidden = true;
  }

  function bindTermsBlock(termsBlock) {
    if (!termsBlock || termsBlock.dataset.bound === 'true') return;
    termsBlock.dataset.bound = 'true';

    const checkbox = termsBlock.querySelector('.cart-terms__checkbox');
    if (checkbox) {
      checkbox.addEventListener('change', function () {
        if (checkbox.checked) hideError(termsBlock);
      });
    }
  }

  function onCheckoutClick(event) {
    const btn = event.target.closest('button[name="checkout"], #checkout, #CartDrawer-Checkout');
    if (!btn) return;
    // Only gate the main Check out button — not Shop Pay / G Pay
    if (btn.closest('.cart__dynamic-checkout-buttons, [data-cart-terms-dynamic]')) return;

    const termsBlock = getTermsBlock(btn);
    if (!termsBlock) return;

    if (!isAgreed(termsBlock)) {
      event.preventDefault();
      event.stopPropagation();
      showError(termsBlock);
    }
  }

  function onFormSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.id !== 'cart' && form.id !== 'CartDrawer-Form') return;

    const submitter = event.submitter;
    if (
      !submitter ||
      (submitter.getAttribute('name') !== 'checkout' &&
        submitter.id !== 'checkout' &&
        submitter.id !== 'CartDrawer-Checkout')
    ) {
      return;
    }

    const termsBlock = getTermsBlock(form) || getTermsBlock(submitter);
    if (!termsBlock) return;

    if (!isAgreed(termsBlock)) {
      event.preventDefault();
      event.stopPropagation();
      showError(termsBlock);
    }
  }

  function init() {
    document.querySelectorAll('[data-cart-terms]').forEach(bindTermsBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', onCheckoutClick, true);
  document.addEventListener('submit', onFormSubmit, true);
  document.addEventListener('cart:updated', init);
  document.addEventListener('cart-drawer:open', init);
})();
